import { Component, OnInit, ElementRef, Renderer, OnDestroy } from '@angular/core';
import { ActivitiesService } from "./activities.service";
import { CatalogoApiService } from 'app/core/api/catalogo-api.service';

declare var $: any;

@Component({
  selector: 'sa-activities',
  templateUrl: './activities.component.html',
  providers: [ActivitiesService],
})
export class ActivitiesComponent implements OnInit, OnDestroy {
  count: number;
  lastUpdate: any;
  active: boolean;
  activities: any;
  currentActivity: any;
  loading: boolean;
  pendientes: any[] = [];
  pendActivo: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer,
    private activitiesService: ActivitiesService,
    private catalogoService: CatalogoApiService
  ) {
    this.active = false;
    this.loading = false;
    this.activities = [];
    this.count = 0;
    this.lastUpdate = new Date();
  }

  ngOnInit() {
    const sucursalRol = JSON.parse(localStorage.getItem('sucursalRol'));

    if (sucursalRol) {
      this.catalogoService.GetResumenPendientes(sucursalRol.sucursal.idSucursal)
        .subscribe(response => {
          if (response.result == 200) {
            this.pendientes = response.data.pendientes;
            this.pendActivo = this.pendientes[0];
            this.count = this.pendientes.reduce((sum, it) => sum + it.total, 0);
            //console.log(this.pendientes);
          }
        });
    }
    // this.activitiesService.getActivities().subscribe(data=> {
    //   this.activities = data;
    //   this.count = data.reduce((sum, it)=> sum + it.data.length, 0);
    //   this.currentActivity = data[0];
    // });
  }

  CalculaTotal() {

  }

  setPendiente(pendiente: any) {
    this.pendActivo = pendiente;
  }

  setActivity(activity) {
    this.currentActivity = activity;
  }

  private documentSub: any;
  onToggle() {
    let dropdown = $('.ajax-dropdown', this.el.nativeElement);
    this.active = !this.active;
    if (this.active) {
      dropdown.fadeIn()


      this.documentSub = this.renderer.listenGlobal('document', 'mouseup', (event) => {
        if (!this.el.nativeElement.contains(event.target)) {
          dropdown.fadeOut();
          this.active = false;
          this.documentUnsub()
        }
      });


    } else {
      dropdown.fadeOut()

      this.documentUnsub()
    }
  }



  update() {
    this.loading = true;
    setTimeout(() => {
      this.lastUpdate = new Date()
      this.loading = false
    }, 1000)
  }


  ngOnDestroy() {
    this.documentUnsub()
  }

  documentUnsub() {
    this.documentSub && this.documentSub();
    this.documentSub = null
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/activities/activities.component.ts